jQuery(document).ready(function ($) {

    if ($(".bloc_paraphotos").length) {

        document.fonts.ready.then(() => {

            $( ".bloc_paraphotos" ).each(function( index ) {

                var cible = $(this)

                let svg = $(this).find(".draw")
                let titre = $(this).find("h2")
                let paragraphe = $(this).find(".paragraphe")
                let chapeau = $(this).find(".chapeau")

                var splitTitre = new SplitText( titre , {
                    type: "lines",
                    tag:'div',
                    reduceWhiteSpace:true,
                    linesClass: "line++"
                })

                var splitPara = new SplitText( paragraphe , {
                    type: "lines",
                    tag:'div',
                    reduceWhiteSpace:true,
                    linesClass: "line++"
                })

                var splitChapeau = new SplitText( chapeau , {
                    type: "chars",
                    tag:'span',
                    reduceWhiteSpace:true,
                    linesClass: "char++"
                })

                var tlParaphoto = gsap.timeline({
                    scrollTrigger: {
                        trigger: cible,
                        markers: false,
                        start: "top 65%"
                    }
                })


                tlParaphoto.from(svg, {
                    drawSVG:0,
                    duration : .6,
                    ease: "power1.out",
                    stagger: 0.1,
                })

                tlParaphoto.from(splitTitre.lines, {
                    opacity : 0,
                    y : 20 ,
                    duration : .6,
                    ease: "power1.out",
                    stagger : 0.1,
                }, "-=1")

                tlParaphoto.from(splitPara.lines, {
                    opacity : 0,
                    y : 20 ,
                    duration : .6,
                    ease: "power1.out",
                    stagger : 0.1,
                }, "-=.6")

                tlParaphoto.from(splitChapeau.chars, {
                    opacity : 0,
                    duration : .9,
                    ease: "power1.out",
                    stagger : 0.07,
                }, "-=.6")





                let visuel = $(this).find(".imageContainer")
                gsap.to(visuel, {
                    top: "-10%",
                    autoRound: true,
                    scrollTrigger: {
                        trigger: cible,
                        start: '0% 100%',
                        end: '100% 0%',
                        scrub: 1,
                        markers: false
                    }
                })


            })

        })



    }

})